import React from 'react';
import { Form, Input, Button,Select,InputNumber,DatePicker,message,Card,Spin,Result, Divider } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import moment from 'moment';
import PhoneInput from 'react-phone-number-input'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';

import {
  Col,
  Row,
} from 'reactstrap';
var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const { TextArea } = Input;
const dateFormat = 'DD/MM/YYYY';
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var sacco= ''
var username=''
var token= ''


class QuickActions extends React.Component {
  state = {
    memberid:'',  
    action:'',
    datarequested:false,
    datasubmittedsuccessfully:false,
    date:moment().format(dateFormat).toString(),  
    journal_txns:[],
    statement_txns:[],
    loanapplications:[],
    loanissuances:[],
    loanassessments:[],
    loanapprovals:[],
    loanshedules:[],
    loanrepayments:[]
  }




  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    const memberid=this.props.memberid;
    this.setState({memberid:memberid})
  }


  //submit button pressed
  onFinish=(event) =>{
    if (this.state.date===""){
      message.error("Date is missing")
    }else{

      this.setState({datarequested:true})

      let form_data = new FormData();
      form_data.append('action', this.state.action);
      form_data.append('sacco', sacco);
      form_data.append('username', username);
      form_data.append('member_id', this.props.memberobj.id);

      ///make a post request now
        axios.post(serverconfig.backendserverurl+'/customqueries/createquick_actions', form_data, {
          headers: {
            'content-type': 'multipart/form-data'
          }
        })
      .then(res => {
        message.info(res.data.message)
        this.setState({datarequested:false})

        if (res.data.message==="success" && this.state.action==="alignstatement" ){
         this.setState({datasubmittedsuccessfully:true})

        }else{

          this.setState({journal_txns:JSON.parse(res.data.journal_txns)})
          this.setState({statement_txns:JSON.parse(res.data.statement_txns)})


          this.setState({loanapplications:JSON.parse(res.data.loanapplications)})
          this.setState({loanassessments:JSON.parse(res.data.loanassessments)})
          this.setState({loanapprovals:JSON.parse(res.data.loanapprovals)})
          this.setState({loanissuances:JSON.parse(res.data.loanissuances)})


          this.setState({loanshedules:JSON.parse(res.data.loanshedules)})
          this.setState({loanrepayments:JSON.parse(res.data.loanrepayments)})

        }

      })
      .catch(error => console.log(error))
    }


    }

    handleactionChange= (e) => {
       this.setState({action:e})
    }



  render(){
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{

      if (this.state.datasubmittedsuccessfully===true){
        return(
            <Card>
            <Result
            status="success"
            title="Successful"
            subTitle="Operation successful"
            extra={[
              <Button  type='primary' onClick={()=>{
                this.setState({datasubmittedsuccessfully:false})
                this.props.onRefresh()
              
              }}>Finish</Button>,
            ]}
            />
            </Card>
        );

      }else{

        return (
          <div>
            <Card>
    
            <Form
                  name="activationform"
                  onFinish={(event) => this.onFinish(event)}
              >

                <FormItem 
                      label="Action"
                      name="action"
                      rules={[
                        {
                          required: true,
                          message: 'Please select action',
                        },
                      ]}
                      >
                          <Select 
                          value={this.state.action} 
                          onChange={this.handleactionChange}
                          placeholder=" Action " >
                                <Option value='alignstatement'>Align Statement</Option>
                                <Option value='export_membersdata'>Export members data</Option>
                          </Select>
                </FormItem>
    
              
                <FormItem>
                  <Button  type="primary" htmlType="submit">Submit</Button>
                </FormItem>
                </Form>
                <br></br>

                {
                  this.state.action==="export_membersdata"?
                  <div>
                    <Divider></Divider>
                    <div style={{justifyContent:'space-between',display:'flex',flexWrap:'wrap',flexDirection:'row'}}>
                    
                    {
                      this.state.statement_txns.length>0?
                      
                        <div style={{margin:3}}>
 <Button 
                        type="primary"
                        onClick={
                        () => {
                          const json = JSON.stringify(this.state.statement_txns, null, 4);
                          console.log(json)
  
                          const blob = new Blob([json], { type: 'application/json' });
                          const url = URL.createObjectURL(blob);
                          const link = document.createElement('a');
                          link.href = url;
                          link.download = this.props.memberobj.FullName+'_tranaction.json';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                          URL.revokeObjectURL(url);  // Clean up the URL.createObjectURL reference
                          }
                        }>
                          Download Transactions JSON
                      </Button>
                      </div>
                      :
                      null
                    }


                  {
                      this.state.journal_txns.length>0?
                                            <div style={{margin:3}}>
                                              <Button type="primary" onClick={
                        () => {
                          const json = JSON.stringify(this.state.journal_txns, null, 4);
                          console.log(json)

                          const blob = new Blob([json], { type: 'application/json' });
                          const url = URL.createObjectURL(blob);
                          const link = document.createElement('a');
                          link.href = url;
                          link.download = this.props.memberobj.FullName+'journals.json';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                          URL.revokeObjectURL(url);  // Clean up the URL.createObjectURL reference
                      }
                      }>
                        Download Journals JSON
                    </Button>

                                          </div>
                    :
                    null}



                    {
                      this.state.loanapplications.length>0?
                                            <div style={{margin:3}}>
                                              <Button type="primary" onClick={
                        () => {
                          const json = JSON.stringify(this.state.loanapplications, null, 4);
                          console.log(json)
                          const blob = new Blob([json], { type: 'application/json' });
                          const url = URL.createObjectURL(blob);
                          const link = document.createElement('a');
                          link.href = url;
                          link.download = this.props.memberobj.FullName+'loanapplications.json';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                          URL.revokeObjectURL(url);  // Clean up the URL.createObjectURL reference
                      }
                      }>
                        Download loanapplications JSON
                    </Button>

                                          </div>
                    :
                    null}



                {
                      this.state.loanassessments.length>0?
                                            <div style={{margin:3}}>
                                              <Button type="primary" onClick={
                        () => {
                          const json = JSON.stringify(this.state.loanassessments, null, 4);
                          console.log(json)
                          const blob = new Blob([json], { type: 'application/json' });
                          const url = URL.createObjectURL(blob);
                          const link = document.createElement('a');
                          link.href = url;
                          link.download = this.props.memberobj.FullName+'loanassessments.json';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                          URL.revokeObjectURL(url);  // Clean up the URL.createObjectURL reference
                      }
                      }>
                        Download loanassessments JSON
                    </Button>

                                          </div>
                    :
                    null}


  {
                        this.state.loanapprovals.length>0?
                                            <div style={{margin:3}}>
                                                <Button type="primary" onClick={
                          () => {
                            const json = JSON.stringify(this.state.loanapprovals, null, 4);
                            console.log(json)
                            const blob = new Blob([json], { type: 'application/json' });
                            const url = URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = this.props.memberobj.FullName+'loanapprovals.json';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            URL.revokeObjectURL(url);  // Clean up the URL.createObjectURL reference
                        }
                        }>
                          Download loanapprovals JSON
                      </Button>

                                            </div>
                      :
                      null}


                  {
                        this.state.loanissuances.length>0?
                                            <div style={{margin:3}}>
                                                <Button type="primary" onClick={
                          () => {
                            const json = JSON.stringify(this.state.loanissuances, null, 4);
                            console.log(json)
                            const blob = new Blob([json], { type: 'application/json' });
                            const url = URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = this.props.memberobj.FullName+'loanissuances.json';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            URL.revokeObjectURL(url);  // Clean up the URL.createObjectURL reference
                        }
                        }>
                          Download loanissuances JSON
                      </Button>

                                            </div>
                      :
                      null}



{
                        this.state.loanshedules.length>0?
                                            <div style={{margin:3}}>
                                                <Button type="primary" onClick={
                          () => {
                            const json = JSON.stringify(this.state.loanshedules, null, 4);
                            console.log(json)
                            const blob = new Blob([json], { type: 'application/json' });
                            const url = URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = this.props.memberobj.FullName+'loanshedules.json';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            URL.revokeObjectURL(url);  // Clean up the URL.createObjectURL reference
                        }
                        }>
                          Download loanshedules JSON
                      </Button>

                                            </div>
                      :
                      null}


                {
                        this.state.loanrepayments.length>0?
                                            <div style={{margin:3}}>
                                                <Button type="primary" onClick={
                          () => {
                            const json = JSON.stringify(this.state.loanrepayments, null, 4);
                            console.log(json)
                            const blob = new Blob([json], { type: 'application/json' });
                            const url = URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = this.props.memberobj.FullName+'loanrepayments.json';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            URL.revokeObjectURL(url);  // Clean up the URL.createObjectURL reference
                        }
                        }>
                          Download loanrepayments JSON
                      </Button>

                                            </div>
                      :
                      null}

                  </div>  

                  </div>
                                
                :
                null
                }

            </Card>
    
     
          </div>
        );

      }

    }

    
  }

}


export default QuickActions;



